module.exports = "<gw-pl-yes-no model=\"fakeVM\"></gw-pl-yes-no>"


//////////////////
// WEBPACK FOOTER
// ./common/grunt/webpack/loaders/text-loader!./common/js/src/edge/policycommon/common/directives/schedules/dataItems/table/templates/Boolean.html
// module id = 1011
// module chunks = 0